"use strict";

var _scatter_swap = require("./scatter_swap");

var _scatter_swap2 = _interopRequireDefault(_scatter_swap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _scatter_swap2.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiQUFBQTs7QUFFQTs7Ozs7O0FBQ0FBLE9BQU9DLE9BQVAiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJcInVzZSBzdHJpY3RcIjtcblxuaW1wb3J0IFNjYXR0ZXJTd2FwIGZyb20gXCIuL3NjYXR0ZXJfc3dhcFwiO1xubW9kdWxlLmV4cG9ydHMgPSBTY2F0dGVyU3dhcDtcbiJdfQ==